import { Control } from "./control";

export class ControlGroup {
    public id: number = 0;
    public name: string = "";
    public description: string = "";
    public instanceGUIDTotalPowerUsed: string = "";
    public totalPowerUsedAddress: string = "";
    public p0: number = 3;
    public p1: number = 3.3;
    public useP1: boolean = false;
    public p2: number = 4;
    public useP2: boolean = false;
    public minPower: number = 2.25;
    public p1P2Time: number = 120;
    public onDelayTime: number = 30;
    public offDelayTime: number = 5;
    public details: Control[] = [];
    public active: boolean = false;

    constructor(controlGroupType?: any) {
        // used for assign type to instance of object
        if (controlGroupType) {
            Object.assign(this, controlGroupType);
        }
    }
}